// Blog Slice
// Full-Width Text
import { PrismicRichText } from '@prismicio/react'

import linkResolver from '@lib/prismic/link-resolver'
import htmlSerializer from '@lib/prismic/serializer'

interface Props {
	slice: any
}

export default function FullWidthText({ slice }: Props) {
	// console.log('FullWidthText Slice ->', slice)

	return (
		<section className="full-width-text section py-0 my-8">
			<div className="container max-w-screen-lg">
				<div className="prose max-w-none text-[16px] md:text-base">
					<PrismicRichText
						field={slice.primary.slice_body}
						linkResolver={linkResolver}
						components={htmlSerializer}
					/>
				</div>
			</div>
		</section>
	)
}
